module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_04 (2).a7ec9497.png";